// Reset default value
// We disable the focus ring for mouse; touch and keyboard users.
// https://github.com/mui/material-ui/blob/master/packages/mui-material/src/ButtonBase/ButtonBase.js
import styled, { css } from 'styled-components';
import { IGutterProps, useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import { IForceFocusOutline, IInvalidProps, useFocusCss } from '../../fundamentals/actions';
import { useCenteredFlexCss } from '../../fundamentals/display';
import { BaseButton } from '../../common/BaseElements';

export type ButtonResetCssProps = IGutterProps & IInvalidProps & IForceFocusOutline;
export const useButtonResetCss = css<ButtonResetCssProps>`
  ${useCenteredFlexCss};
  position: relative;

  user-select: none;
  font-family: inherit;

  ${useGutterAsMarginCss()};
  ${useFocusCss()};
`;

export interface IButtonRoot {
  noWrap?: boolean;
}

export const ButtonRoot = styled(BaseButton)<IButtonRoot & IGutterProps & IInvalidProps & IForceFocusOutline>`
  appearance: none; // Reset
  text-decoration: none;
  ${({ noWrap }) =>
    !noWrap &&
    css`
      white-space: nowrap;
    `}

  -webkit-tap-highlight-color: transparent;
  background-color: transparent;
  outline: 0;
  border: 0;
  padding: 0; // Remove the padding in Firefox

  &::-moz-focus-inner {
    border-style: none; // Remove Firefox dotted outline.
  }

  @media print {
    color-adjust: exact;
  }

  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  ${useButtonResetCss};
`;

export const useButtonOpacityStateCss = css`
  opacity: 0.5;

  &:hover {
    opacity: 0.75;
  }
  &:active {
    opacity: 1;
  }
`;
